import { Directive, OnInit, OnDestroy, Injectable, Inject, forwardRef, Input } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import {   PersonDataService } from '../data-services';
import { ODataBindingDirective } from './core/o-data-binding-directive';
import { ODataEntitySetResource } from 'angular-odata';

@Injectable()
@Directive({
  selector: '[personDataBinding]'
})
export class PersonDataBindingDirective extends ODataBindingDirective  {

  @Input('personDataBinding') query:  ODataEntitySetResource<any>;
    
    constructor(@Inject(forwardRef(() =>PersonDataService)) dataService: PersonDataService, @Inject(forwardRef(() => GridComponent))  grid: GridComponent) {
        super(dataService,grid);
    }
    public ngOnChanges( c: any ) : void {
 
        console.log( "person-Query:", this.query);
        this.rebind();
    }

}
